/* unplugin-vue-components disabled */import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"

import "./Show.vue?vue&type=style&index=0&id=884c04c4&lang=scss"

const __exports__ = script;

export default __exports__